const prependTitle = 'ServiceQuery';

//@ts-ignore
export const CreateServiceQuery = (queryName, callback) => {
    window.addEventListener(`${prependTitle}.query.${queryName}`, ({ detail }: CustomEvent) => {
        const response = { uid: detail.uid, response: callback(detail.options) };
        window.dispatchEvent(
            new CustomEvent(`${prependTitle}.response.${queryName}`, { detail: response })
        );
    });

    window.dispatchEvent(new CustomEvent(`${prependTitle}.ready.${queryName}`));
};
